import { render, staticRenderFns } from "./Tencent.vue?vue&type=template&id=e3aae9ec&"
import script from "./Tencent.vue?vue&type=script&lang=js&"
export * from "./Tencent.vue?vue&type=script&lang=js&"
import style0 from "./Tencent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports